const DATE_ONLY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;
const UTC_MIDNIGHT_PATTERN = /^\d{4}-\d{2}-\d{2}T00:00:00(?:\.000)?Z$/;

export function formatDate(value: string | null | undefined): string {
  if (!value) {
    return '-';
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return String(value);
  }
  const useUtcCalendarDay = DATE_ONLY_PATTERN.test(value) || UTC_MIDNIGHT_PATTERN.test(value);
  return new Intl.DateTimeFormat(undefined, {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    ...(useUtcCalendarDay ? { timeZone: 'UTC' } : {}),
  }).format(date);
}

export function toDateInputValue(value: string | null | undefined): string {
  if (!value) {
    return '';
  }
  if (DATE_ONLY_PATTERN.test(value)) {
    return value;
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '';
  }
  return date.toISOString().slice(0, 10);
}

export function toIsoFromDateInput(value: string): string | null {
  const text = String(value || '').trim();
  if (!/^\d{4}-\d{2}-\d{2}$/.test(text)) {
    return null;
  }
  return `${text}T00:00:00.000Z`;
}

export function randomIdempotencyKey(): string {
  if (window.crypto && typeof window.crypto.randomUUID === 'function') {
    return window.crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

export function sumNumbers(values: number[]): number {
  return values.reduce((sum, value) => sum + (Number.isFinite(value) ? value : 0), 0);
}

export function formatWholeNumber(value: number): string {
  return Number.isFinite(value) ? String(Math.round(value)) : '-';
}

export function formatOneDecimal(value: number): string {
  return Number.isFinite(value) ? value.toFixed(1) : '-';
}
